import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const ThreeDimensionSectionSettings = (settingsProps) => {
  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="text"
          type="text"
          label="Text"
          defaultValue={defaultProps['text']}
        />
      </ToolbarSection>
      <div className="empty-message">
        <p>No options available</p>
      </div>
      {!settingsProps.floating && (
        <>
          <ImageToolbarSection defaultProps={defaultProps} />
          <CtaToolbarSection defaultProps={defaultProps} />
        </>
      )}
    </>
  )
}

export const ThreeDimensionSectionFloatingSettings = () =>
  React.createElement(ThreeDimensionSectionSettings, { floating: true })
